/**
 * @desc 导出
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EnvironmentalMonitoringExportRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/monitoring/export',
    data,
  });
}

export function mock(
  data: defs.EnvironmentalMonitoringExportRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/monitoring/export',
    data,
  });
}
